<script setup lang="ts">
const openContactForm = ref(false);

const background = computed(() => {
  return `url(${useCdnUrl()}/assets/backgrounds/contact-background.webp)`;
});
</script>

<template>
  <div class="contact-block">
    <ContentBlockSpacer />
    <div class="questions-block-details">
      <h2><slot name="title">Questions?</slot></h2>
      <div>
        <TheCtaButton @click="openContactForm = true"> Contact Us </TheCtaButton>
      </div>
    </div>
    <Teleport to="body">
      <ModalBackdrop v-if="openContactForm" @close="openContactForm = false">
        <Contact class="contact-modal" />
      </ModalBackdrop>
    </Teleport>
  </div>
</template>

<style lang="scss">
.contact-block {
  background-image: v-bind(background);
  background-size: cover;
  margin: auto;
  max-width: 1366px;
  position: relative;
  text-align: center;
  width: 100%;

  .questions-block-details {
    display: flex;
    flex-direction: column;
    gap: 3rem;
    padding: 8rem 2rem;

    h2 {
      color: white;
      font-size: 4rem;
      font-weight: 200;
      margin: 0;
      padding: 0;
    }
  }
}

.contact-modal {
  .container {
    padding: 3rem 2rem 3rem !important;
    .contact-form {
      max-width: 1000px;
      width: 80%;

      @media only screen and (max-width: 768px) {
        width: 100%;
      }
    }
  }
}
</style>
